import { render, staticRenderFns } from "./ChangeBrandPhotoPopup.vue?vue&type=template&id=3e2e13ed&scoped=true&"
import script from "./ChangeBrandPhotoPopup.vue?vue&type=script&lang=ts&"
export * from "./ChangeBrandPhotoPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeBrandPhotoPopup.vue?vue&type=style&index=0&id=3e2e13ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2e13ed",
  null
  
)

export default component.exports